import React from 'react'
import Header from '../Header'
import injectSheet from 'react-jss'
import style from './style'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import sortBy from 'ramda/src/sortBy'

const subjectLine = (fn, search) => fn() && complement(isEmpty)(search) ? `Camera To Add - model ${search}` : 'Camera To Add'
const messageLine = (fn, search) => fn() && complement(isEmpty)(search) ? `Please add camera model ${search}` : 'Please add'
const linkText = (fn, search) => fn() && complement(isEmpty)(search) ? search : 'a missing camera'

const NoMatch = ({ classes, filtersAreInitial, search, selectedManufacturer, filterCameras }) =>
  <div className={classes.NoMatch}>
    <div className={classes.line1}>
      { selectedManufacturer ? `No matching ${selectedManufacturer} cameras!` : 'No matching cameras!' }
    </div>
    { selectedManufacturer &&
      <div onClick={_ => filterCameras({}, '', null, true)} className={classes.resetButton}>
        <FontAwesomeIcon icon={['far', 'times-circle']} className={classes.resetIcon} />
        Clear search
      </div>
    }
    { !filtersAreInitial() && <div className={classes.line2}>Try widening your filters</div> }
    <hr className={classes.break} />
    <a
      href={`${IPVM_URL}/contact?subject=${subjectLine(filtersAreInitial, search)}&message=${messageLine(filtersAreInitial, search)}`}
      target='_blank'
      className={classes.missingCameraLink}
    >
      Missing camera?
      <br />
      Request us to add {linkText(filtersAreInitial, search)} now
    </a>
  </div>

const ListItem = ({ data, index, style }) => {
  const { cameras, classes, selectedCamera, updateCameraList, favoriteModels, recentModels } = data
  const camera = cameras[index]

  return (
    <div
      onClick={_ => updateCameraList(camera)}
      className={selectedCamera && camera.model === selectedCamera.model ? classes.selected : (index % 2 === 0 ? classes.listItemOdd : classes.listItemEven)}
      style={style}
    >
      <span className={classes.cameraModel}>{camera.model}</span>
      {
        recentModels.includes(camera.id) &&
        <FontAwesomeIcon icon={'history'} className={classes.clock} />
      }
      {
        favoriteModels.includes(camera.id) &&
        <FontAwesomeIcon icon='star' className={classes.star} />
      }
      {
        camera.discontinued &&
        <span className={classes.eolSpan}>EOL</span>
      }
    </div>
  )
}

const cameraData = ({ cameras, selectedCamera, classes, updateCameraList, favoriteModels, recentModels }) => ({
  cameras: sortBy(c => recentModels.includes(c.id) ? (favoriteModels.includes(c.id) ? 0 : 1) : (favoriteModels.includes(c.id) ? 2 : 3))(cameras),
  selectedCamera,
  classes,
  updateCameraList,
  favoriteModels,
  recentModels
})

const CameraList = injectSheet(style)((props) => {
  const { cameras, classes } = props

  return (
    <div className={classes.CameraList}>
      <Header title='Models' />
      {
        isEmpty(cameras)
        ? <div className={classes.list}>
            <NoMatch {...props} />
          </div>
        : <div style={{ flex: '1 1 auto' }}>
            <AutoSizer disableWidth>
              {({ height }) => (
                <List
                  height={height}
                  itemCount={cameras.length}
                  itemData={cameraData(props)}
                  itemSize={27}
                  width={'100%'}
                  className={classes.list}
                >
                  { ListItem }
                </List>
              )}
            </AutoSizer>
          </div>
      }
    </div>
  )
})

export default injectSheet(style)(CameraList)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraList/index.js